import { createTheme, type MantineTheme, Text } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

export const ThemedMantineText: PartialDeep<MantineTheme> = createTheme({
  components: {
    Text: Text.extend({}),
  },
});
